import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchChannelFees,
  fetchExchangeRates,
  fetchExchangeRatesSettings,
  fetchExchangeRateWithFee,
  fetchSingleChannelFee,
  fetchSingleExchangeRate,
} from "../exchangeRates/thunkActions";

interface InitialState {
  isLoading: boolean;
  isLoadingSettings: boolean;
  exchangeRates: any;
  settings: IExchangeRatesSettings | null;
  singleExchangeRate: any;
  isFetchingExchangeRateDetails: boolean,
  channelFees: any;
  singleChannelFee: any;
  isLoadingChannel: boolean;
  isFetchingChannelFeeDetails: boolean
}

const initialState: InitialState = {
  exchangeRates: [],
  isLoading: false,
  settings: null,
  isLoadingSettings: false,
  singleExchangeRate: null,
  isFetchingExchangeRateDetails: false,
  channelFees: [],
  singleChannelFee: null,
  isLoadingChannel: false,
  isFetchingChannelFeeDetails: false
};

const exchangeRatesSlice = createSlice({
  name: "exchangeRates",
  initialState,
  reducers: {
    clearExchangeRates: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.exchangeRates = [];
      }
    },
    clearExchangeRate: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.singleExchangeRate = null;
      }
    },    
    clearChannelFees: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.channelFees = null;
      }
    },
    clearChannelFee: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.singleChannelFee = null;
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchExchangeRates.pending, (state) => {
      state.exchangeRates = [];
      state.isLoading = true;
    })
    .addCase(fetchExchangeRates.fulfilled, (state, action) => {
      state.exchangeRates = action.payload;
      state.isLoading = false;
    })
    .addCase(fetchExchangeRates.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(fetchExchangeRatesSettings.pending, (state) => {
      state.settings = null;
      state.isLoadingSettings = true;
    })
    .addCase(fetchExchangeRatesSettings.fulfilled, (state, action) => {
      state.settings = action.payload as IExchangeRatesSettings;
      state.isLoadingSettings = false;
    })
    .addCase(fetchExchangeRatesSettings.rejected, (state) => {
      state.isLoadingSettings = false;
    });

    builder.addCase(fetchChannelFees.pending, (state) => {
      state.channelFees = [];
      state.isLoadingChannel = true;
    })
    .addCase(fetchChannelFees.fulfilled, (state, action) => {
      state.channelFees = action.payload;
      state.isLoadingChannel = false;
    })
    .addCase(fetchChannelFees.rejected, (state) => {
      state.isLoadingChannel = false;
    });

    builder.addCase(fetchSingleExchangeRate.pending, (state) => {
      state.isFetchingExchangeRateDetails = true;
    })
    .addCase(fetchSingleExchangeRate.fulfilled, (state, action) => {
      state.singleExchangeRate = action.payload;
      state.isFetchingExchangeRateDetails = false;
    })
    .addCase(fetchSingleExchangeRate.rejected, (state) => {
      state.isFetchingExchangeRateDetails = false;
    });

    builder.addCase(fetchExchangeRateWithFee.pending, (state) => {
      state.isFetchingExchangeRateDetails = true;
    })
    .addCase(fetchExchangeRateWithFee.fulfilled, (state, action) => {
      state.singleExchangeRate = action.payload;
      state.isFetchingExchangeRateDetails = false;
    })
    .addCase(fetchExchangeRateWithFee.rejected, (state) => {
      state.isFetchingExchangeRateDetails = false;
    });

    builder.addCase(fetchSingleChannelFee.pending, (state) => {
      state.isFetchingChannelFeeDetails = true;
    })
    .addCase(fetchSingleChannelFee.fulfilled, (state, action) => {
      state.singleChannelFee = action.payload;
      state.isFetchingChannelFeeDetails = false;
    })
    .addCase(fetchSingleChannelFee.rejected, (state) => {
      state.isFetchingChannelFeeDetails = false;
    });
  },
});

export default exchangeRatesSlice.reducer;
export const { clearExchangeRates, clearExchangeRate, clearChannelFee, clearChannelFees } = exchangeRatesSlice.actions;
export * from "./thunkActions";
